import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useAuth } from 'lib/context';

export const CompanyRoutes = () => {
  const { whitelabel } = useAuth();

  return (
    <Switch>
      <Route
        path='/company/Company_ManageAssignedUsers'
        component={() => {
          window.location.href = `https://${whitelabel.domainV2}/backoffice/Company_ManageAssignedUsers.php`;
          return null;
        }}
      />
      <Route
        path='/company/Company_Graphics'
        component={() => {
          window.location.href = `https://${whitelabel.domainV2}/backoffice/Company_Graphics.php`;
          return null;
        }}
      />
    </Switch>
  );
};
